
export const msgSimple = (message) => dispacth =>{
    return new Promise(resolve =>{
        dispacth({type:'close'})
        setTimeout(()=>{
            dispacth({type:'showSimple', payload:{message}})
            setTimeout(() =>{
                dispacth({type:'close'})
            }, 5000)
        }, 500)
    })
}
export const msgError = (message) => dispacth =>{
    return new Promise(resolve =>{
        dispacth({type:'close'})
        setTimeout(()=>{
            dispacth({type:'showError', payload:{message}})
            setTimeout(() =>{
                dispacth({type:'close'})
            }, 5000)
        }, 500)
    })
}
export const msgAction = (message, callbackText, callback) => dispacth =>{
    return new Promise(resolve =>{
        dispacth({type:'close'})
        setTimeout(()=>{
            dispacth({type:'showAction', payload:{message,  callbackText, callback}})
            setTimeout(() =>{
                dispacth({type:'close'})
            }, 7000)
        }, 500)
    })
}
export const closeSnackbar = () => {
    return { type: 'close'}
}




// WEBPACK FOOTER //
// ./src/actions/snackbarActions.js